import {Injectable, Inject} from '@angular/core';
import {HttpClient, HttpHeaders, HttpResponse} from "@angular/common/http";
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';
import {HttpOptions} from '../../modele/authModel';
import {SpotifyChannel} from "../../modele/social-media/spotifyModels";
import {BackendService} from "../api/backend.service";
import {SpotifyAuthorization} from "../../modele/backendResponses";
import {NGXLogger} from "ngx-logger";

export const SPOTIFY_API_KEY = 'b0c1dc999363efd716d3b593b8fca91c';
export const SPOTIFY_API_URL = 'https://api.spotify.com/v1/search';
export const SPOTIFY_API_URL2 = 'https://api.spotify.com/v1/artists';

@Injectable({
    providedIn: 'root'
})
export class SpotifyService {

    log_prefix = this.constructor.name + ":";
    private auth_url: string;
    private local_auth:SpotifyAuthorization;

    constructor(private http: HttpClient, private bes: BackendService,private logger:NGXLogger,
                @Inject(SPOTIFY_API_KEY) private apiKey: string,
                @Inject(SPOTIFY_API_URL) private apiUrl: string,
                @Inject(SPOTIFY_API_URL2) private apiUrl2: string) {
        this.auth_url = this.bes.getBackendThirdPartyRestApiSpotifyAutorization();
        this.getBackendAuthorization()
        this.local_auth = {
            oAuth2AccessToken:  "cjkdsckdsjckdsvlkdjfvlkjdslkvjdslvjsdlkcjsdkljsjalcsdkjcldsjlkjdvljvsdljksdvjdlvjsdjkvsjdv",
            expires_on:  "",
            expires_in:1,
        }
    }

    private getBackendAuthorization() {
        let lp=this.log_prefix+"getBackendAuthorization:";
        this.http.get<SpotifyAuthorization>(this.auth_url).subscribe((resp:SpotifyAuthorization)=>{
            let {oAuth2AccessToken} = resp;
            let {expires_on} = resp;
            let {expires_in} = resp;
            this.local_auth = resp;
        })

    }

    // search(query: string): Observable <SpotifyChannel[] > {
    search(query: string): Observable <any> {

        let lp=this.log_prefix+"search:";
        //const access_token = 'BQDoLp9CkuzhOQ2R4xQ72OySj3D45_dFNVNq7z0psPUHLdy8Q35vdUetHRcu61v0jUGDzjYw9PSv-4nqez0nbq9mJXNFjQPif1LFIdCdzHulp7dcj7n1j5FnmUvd2g'
        const access_token = this.local_auth.oAuth2AccessToken;
        const headers = new HttpHeaders({'Authorization': 'Bearer ' + access_token});
        // let options = new HttpOptions({ headers: headers });
        let options = new HttpOptions();
        options.setHttpHeaders(headers);
        const params = `query=${query}&type=artist`;
        const queryUrl = `${this.apiUrl}?${params}`;

        // return new Observable<SpotifyChannel[]>((observer) => {
        return new Observable<any>((observer) => {
            // let list: SpotifyChannel[] = [];
            // observer.next(list);
            this.http.get(queryUrl, options).subscribe((response: HttpResponse<any>) => {
                observer.next(response);
            });
        });
    }

    // getSpotifyFeed(query: string): Observable <SpotifyChannel[] > {
    getSpotifyFeed(query: string): Observable <any[] > {

        let lp=this.log_prefix+"getSpotifyFeed:";
        //const access_token = 'BQDoLp9CkuzhOQ2R4xQ72OySj3D45_dFNVNq7z0psPUHLdy8Q35vdUetHRcu61v0jUGDzjYw9PSv-4nqez0nbq9mJXNFjQPif1LFIdCdzHulp7dcj7n1j5FnmUvd2g'
        const access_token = this.local_auth.oAuth2AccessToken;
        const headers = new HttpHeaders({'Authorization': 'Bearer ' + access_token});
        let options = new HttpOptions();
        options.setHttpHeaders(headers);
        const params = `${query}/albums`;
        const queryUrl = `${this.apiUrl2}/${params}`;
        // this.http.get(queryUrl, options).map((response: HttpResponse<any>) => {
        //     //todo: ^^
        //     return [];
        //     //return (<any>response)
        // });
        // return new Observable<SpotifyChannel[]>((observer) => {
        //     let list: SpotifyChannel[] = [];
        //     observer.next(list);
        // });

        return new Observable<any>((observer) => {
            // let list: SpotifyChannel[] = [];
            // observer.next(list);
            this.http.get(queryUrl, options).subscribe((response: HttpResponse<any>) => {
                let items = response['items'];

                observer.next(response);
            });
        });
    }
}
